import { transformToProductCategory } from '../../@products/ProductCategory/ProductCategoryTransformers';
import { BlockType } from '../../Block/Block';
import { transformToDefaultBlock } from '../../Block/BlockTransformers';
import { CategorySliderInterface, CategorySliderResource } from './CategorySlider';

export const transformToCategorySlider = (resource: CategorySliderResource): CategorySliderInterface => {
    const defaultBlock = transformToDefaultBlock(resource);

    const categories = resource.categories
        ? resource.categories.map(category => transformToProductCategory(category, resource.layout))
        : [];

    const title = resource.title || undefined;

    return {
        ...defaultBlock,
        type: BlockType.categorySlider,
        categories,
        title,
    };
};
